import { LgaDto, CountryDto, StateDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Lga Collection Actions
 */
export const loadLga = createAction('[Lga] Load Lga');

export const loadLgaSuccess = createAction(
  '[Lga] Load Lga Success',
  props<{ lga: LgaDto[] }>()
);

export const loadLgaFailure = createAction(
  '[Lga] Load Lga Failure',
  props<{ error: any }>()
);

/**
 * Add Lga to Collection Actions
 */
export const addLga = createAction(
  '[Lga] Add Lga',
  props<{ newLga: LgaDto[] }>()
);

export const addLgaSuccess = createAction(
  '[Lga] Add Lga Success',
  props<{ newLga: LgaDto[] }>()
);

export const addLgaFailure = createAction(
  '[Lga] Add Lga Failure',
  props<{ error: any }>()
);

/**
 * Select Country to Collection Actions
 */
export const selectCountry = createAction(
  '[Country] Select Country',
  props<{ selectCountry: CountryDto[] }>()
);

export const selectCountrySuccess = createAction(
  '[Country] Select Country Success',
  props<{ newCountry: CountryDto[] }>()
);

export const selectCountryFailure = createAction(
  '[Country] Select State Failure',
  props<{ error: any }>()
);

/**
 * Select State to Collection Actions
 */
export const selectState = createAction(
  '[State] Select State',
  props<{ selectState: StateDto[] }>()
);

export const selectStateSuccess = createAction(
  '[State] Select State Success',
  props<{ newState: StateDto[] }>()
);

export const selectStateFailure = createAction(
  '[State] Select State Failure',
  props<{ error: any }>()
);

/**
 * Update Lga Collection Actions
 */
export const updateLga = createAction(
  '[Lga] Update Lga',
  props<{ updateLga: LgaDto[] }>()
);

export const updateLgaSuccess = createAction(
  '[Lga] Update Lga Success',
  props<{ updateLga: LgaDto[] }>()
);

export const updateLgaFailure = createAction(
  '[Lga] Update Lga Failure',
  props<{ error: any }>()
);

/**
 * Remove Lga Collection Actions
 */
export const removeLga = createAction(
  '[Lga] Remove Lga',
  props<{ ids: string[] }>()
);

export const removeLgaSuccess = createAction(
  '[Lga] Remove Lga Success',
  props<{ ids: string[] }>()
);

export const removeLgaFailure = createAction(
  '[Lga] Remove Lga Failure',
  props<{ error: any }>()
);
